import script from "./UsersBalanceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersBalanceTable.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./UsersBalanceTable.vue?vue&type=style&index=0&id=6affd711&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__